function paymentMsgExpand() {
    const list = document.querySelector(".sk-list--split-horizontal");

    if (list) {
        list.querySelectorAll(".sect-opener").forEach((opener) => {
            let li = opener.closest("li"); // Find the parent <li>
            let count = 0;
            let next = li.nextElementSibling;

            // Hide the next 5 <li> elements on initialization
            opener.classList.add("hide-list")
            while (next && count < 5) {
                next.classList.add("hidden");
                next = next.nextElementSibling;
                count++;
            }

            // Add click event to toggle visibility
            opener.addEventListener("click", () => {
                let count = 0;
                let next = li.nextElementSibling;
                opener.classList.toggle("hide-list");


                while (next && count < 5) {
                    next.classList.toggle("hidden");
                    next = next.nextElementSibling;
                    count++;
                }
            });
        });
    }
}

export { paymentMsgExpand };